$(document).ready(function() {
    loadAndResizeEvents();

    // animation
    if(document.documentElement.clientWidth >= 1200) {
        var start = Date.now();

        var timerId = setInterval(function() {

          var timePassed = Date.now() - start;

          if (timePassed >= 2000) {
              $('.twister-pulse').removeClass('animation');
          }

          if (timePassed >= 3000) {
              $('.twister-pulse').addClass('animation');
          }

          if (timePassed >= 6000) {
              start = Date.now();
              timePassed = 0;
          }

        }, 20);
    }
});

$(window).resize(loadAndResizeEvents);

function loadAndResizeEvents() {

    var contentWidth = $('.twister-header').width();
    var contentHeight = contentWidth * 9/16;

    const offsetTop = 60;
    const padding = 80;
    var contentMinHeight = $('.twister-h1-block').height() + padding + offsetTop;
    if(contentHeight < contentMinHeight) {
        contentHeight = contentMinHeight;
    }
    $('.twister-presentation-block').css({ 'width' : contentWidth, 'height': contentHeight});

    setTimeout(function() {
        contentMinHeightCheck = $('.twister-h1-block').height() + padding + offsetTop;
        if(contentMinHeight < contentMinHeightCheck) {
            $('.twister-presentation-block').css({ 'width' : contentWidth, 'height': contentMinHeightCheck});
        }
    }, 250);
}



// WEBPACK FOOTER //
// ./assets/js/sale-page.js